'use client';
var YM_SOURCE = "https://mc.yandex.ru/metrika/tag.js";

export { YM_SOURCE };
